import { render, staticRenderFns } from "./opinion_polls.vue?vue&type=template&id=1608255e&scoped=true&"
import script from "./opinion_polls.vue?vue&type=script&lang=js&"
export * from "./opinion_polls.vue?vue&type=script&lang=js&"
import style0 from "./opinion_polls.vue?vue&type=style&index=0&class=scss&lang=css&"
import style1 from "./opinion_polls.vue?vue&type=style&index=1&id=1608255e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1608255e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VForm,VRadio,VRadioGroup,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1608255e')) {
      api.createRecord('1608255e', component.options)
    } else {
      api.reload('1608255e', component.options)
    }
    module.hot.accept("./opinion_polls.vue?vue&type=template&id=1608255e&scoped=true&", function () {
      api.rerender('1608255e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/opinion_polls.vue"
export default component.exports